<h2 mat-dialog-title>Add Field</h2>
<mat-dialog-content class="container" [formGroup]="fieldForm">
  <div style="display: flex; flex-direction: row;">
    <mat-form-field class="full-width--minus-icon">
      <mat-label>--- Select Section ---</mat-label>
      <mat-select formControlName="selectParentSelection" (selectionChange)="sectionChanged($event)" [(value)]="parentSectionId">
        <mat-option *ngFor="let section of fields" [value]="section.id">{{section.label}}</mat-option>
      </mat-select>
      @if (fieldForm.controls['selectParentSelection'].invalid && (fieldForm.controls['selectParentSelection'].dirty || fieldForm.controls['selectParentSelection'].touched)) {
      <mat-error>
        <p>Must select a section.</p>
      </mat-error>
      }
    </mat-form-field>
    <button mat-icon-button style="margin-top: 5px;" color="primary" matTooltip="Add New Section" (click)="createNewSection()"><mat-icon>add</mat-icon></button>
  </div>
  <div *ngIf="isNewSection">
    <mat-form-field class="full-width">
      <mat-label>Section</mat-label>
      <input matInput formControlName="newParentSection" required>
      @if(fieldForm.controls['newParentSection'].invalid && (fieldForm.controls['newParentSection'].dirty || fieldForm.controls['newParentSection'].touched)) {
      <mat-error>
        <p *ngIf="fieldForm.controls['newParentSection'].errors.required">Parent title is required.</p>
        <p *ngIf="fieldForm.controls['newParentSection'].errors.duplicateTitle">Title already in use. Please use a different Title.</p>
      </mat-error>
      }
    </mat-form-field>
  </div>
  <mat-form-field class="full-width">
    <mat-label>Field Title</mat-label>
    <input matInput formControlName="newFieldTitle" required>
    @if (fieldForm.controls['newFieldTitle'].invalid && (fieldForm.controls['newFieldTitle'].dirty || fieldForm.controls['newFieldTitle'].touched)) {
    <mat-error>
      <p *ngIf="fieldForm.controls['newFieldTitle'].errors.required">Title is required.</p>
      <p *ngIf="fieldForm.controls['newFieldTitle'].errors.duplicateTitle">Title already in use. Please use a different Title.</p>
    </mat-error>
    }
  </mat-form-field>
  <div class="radio-container">
    <mat-label>Field Type</mat-label>
    <mat-radio-group formControlName="fieldType" class="radio-group" matInput aria-label="Select Field Type">
      <mat-radio-button *ngFor="let type of fieldTypes" [value]="type.value" style="margin: 4px 0;">
        {{type.displayName}}
      </mat-radio-button>
    </mat-radio-group>
    <mat-error *ngIf="fieldForm.controls['fieldType'].invalid && (fieldForm.controls['fieldType'].dirty || fieldForm.controls['fieldType'].touched)">
      <p>Must select a Field Type.</p>
    </mat-error>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" [disabled]="fieldForm.invalid" (click)="ok()">Create</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>